import React from "react";
import "./CartSteps.css";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import { useNavigate } from "react-router-dom";

function CartSteps({
  activeStep = 1,
  setActiveStep,
  checkoutStep = 1,
  setCheckoutStep,
}) {

  const navigate = useNavigate();
  const steps = [
    { id: 1, label: "Cart" },
    { id: 2, label: "Checkout" },
    { id: 3, label: "Confirmation" },
  ];



  const handleStepBack = () => {
  // STEP 1 → go to previous page
  if (activeStep === 1) {
    navigate(-1); // browser back
    return;
  }

  // If user is inside Checkout (Step 2) and on inner screen
  if (activeStep === 2 && checkoutStep > 1) {
    setCheckoutStep(checkoutStep - 1);
    return;
  }

  // Normal back for main steps
  if (activeStep > 1) {
    setActiveStep(activeStep - 1);
  }
};

  return (
    <div className="cart_steps">
      <div className="custom_container">
        {/* Back Button */}
        <Common_Back_Btn backText="Back" onClick={handleStepBack} />

        <div className="steps_line_holder">
          {/* BASE LINE */}
          <div className="base_line"></div>

          {/* ACTIVE LINE */}
          <div
            className="active_line"
            style={{
              width:
                activeStep === 1 ? "20%" : activeStep === 2 ? "50%" : "100%",
            }}
          ></div>

          {/* STEPS */}
          <div className="steps_points_holder">
            {steps.map((step) => {
              const isActive = activeStep >= step.id;
              const isCurrent = activeStep === step.id;

              return (
                <div className="step_item" key={step.id}>
                  <p className="step_label">{step.label}</p>

                  <span
                    className={`step_dot ${isActive ? "active" : "inactive"} ${
                      isCurrent ? "current" : ""
                    }`}
                  ></span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartSteps;
